/* unplugin-vue-components disabled */import script from "./jsonexcelPage.vue?vue&type=script&setup=true&lang=js"
export * from "./jsonexcelPage.vue?vue&type=script&setup=true&lang=js"

import "./jsonexcelPage.vue?vue&type=style&index=0&id=08b70d06&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08b70d06"]])

export default __exports__